export const API_ENDPOINTS = {
  getConfig: '/config',
  INSPECTION: {
    INSPECTIONS: 'inspections',
    SYNC: 'inspections/sync',
    FACTORY_VISIT_SESSION_ACTIVE: 'inspections/factory-visit-session/active',
  },
  META: {
    CLIENT_DECISIONS: 'meta/client-decisions',
    CONTROL_POINTS: 'meta/control-points',
    DEFECT_CATEGORIES: 'meta/defects',
    DIVISIONS: 'meta/divisions',
    STATUS: 'meta/inspection-statuses',
    LEVELS: 'meta/inspection-levels',
    AQL_LEVELS: 'meta/aql-levels',
    IMAGE_CATEGORIES: 'meta/image-categories',
    CHECKPOINT_CHECKS: 'meta/checkpoint-checks',
  },
  FILE: {
    GET_URL: 'files/generate-upload-url',
    UPLOAD: 'files/upload',
  },
  AUTH: {
    LOGIN: 'auth/login',
    LOGOUT: 'auth/logout',
  },
  LOGS: {
    LOGS: 'logs',
  },
};
